import "./not-found-page.css";
import { Helmet } from 'react-helmet-async';
import Navbar from '../../components/navbar/navbar';

const notFoundPage = () => {
    return(
        <div>
            <Helmet>
                <title>Page Not Found | Handyman In Melbourne</title>
                <meta name="robots" content="noindex, follow" />
            </Helmet>

            <a className="skip-link" href="#main-content">Skip to main content</a>
            <Navbar />
            <main id="main-content" className="main-container">
                <h1>The page you’re looking for can’t be found.</h1>
            </main>
        </div>
    )
}

export default notFoundPage;
